export const getDefaultFilterOptions = () => {
  return {
    admissionCategory: 'ONSHORE-UNDERGRAD-DOMESTIC',
    courseAttemptStatus: 'ENROLLED',
    teachingPeriods: ['H2B1'],
    college: 'COLEGE OF ARTS AND EDUCATION',
    campus: 'F'
  };
};

const LIVEVIEW_FILTER_NAME = 'LIVEVIEW_FILTER_OPTIONS';

const PREVIEW_ENABLED_NAME = 'PREVIEW_MODE_ENABLED';

export const loadFilterOptions = () => {
  const savedFilterOptionsStr = sessionStorage.getItem(LIVEVIEW_FILTER_NAME);
  return savedFilterOptionsStr ? JSON.parse(savedFilterOptionsStr) : null;
};

export const saveFilterOptions = filterOptions => {
  const filterOptionsStr = JSON.stringify(filterOptions);
  sessionStorage.setItem(LIVEVIEW_FILTER_NAME, filterOptionsStr);
};

export const getPreviewModeEnabled = () => {
  const previewModeState = sessionStorage.getItem(PREVIEW_ENABLED_NAME);
  return previewModeState == 'true' ? true : false;
};

export const setPreviewModeEnabled = isPreviewEnabled => {
  sessionStorage.setItem(PREVIEW_ENABLED_NAME, isPreviewEnabled);
};
